import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import {
  FixaAccordion,
  FixaAccordionItem,
} from "@coworker/apprestructured/src/shared/wrappers/FixaAccordion/FixaAccordion";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./unauthorizedpage.module.css";
import { useTranslation } from "@coworker/locales";

const roleTypesContext = {
  coworker: {
    translationKey: "unauthorizedCoworkerDisclaimerTitleString",
    myIdentityLink:
      "https://myidentity.apps.ikea.com/IdentityManager/page.axd?ContextID=VI_ITShop_ProductSelection&uid_accproduct=9cc420f7-a2a8-427c-9582-aa43446ef290",
  },
  storeSuperUser: {
    translationKey: "unauthorizedStoreSuperUserDisclaimerTitleString",
    myIdentityLink:
      "https://myidentity.apps.ikea.com/IdentityManager/page.axd?ContextID=VI_ITShop_ProductSelection&uid_accproduct=14c52d7b-ce0e-4f2a-984b-d585a523664a",
  },
  countrySuperUser: {
    translationKey: "unauthorizedCountrySuperUserDisclaimerTitleString",
    myIdentityLink:
      "https://myidentity.apps.ikea.com/IdentityManager/page.axd?ContextID=VI_ITShop_ProductSelection&uid_accproduct=befa0173-d693-447d-965c-28e21f92247b",
  },
};

const UnauthorizedPageAccordion = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["faq-section"]}>
      <FixaAccordion padded>
        {Object.entries(roleTypesContext).map(
          ([key, { translationKey, myIdentityLink }]) => (
            <FixaAccordionItem
              key={key}
              id={`unauthorized-${key}`}
              title={t(translationKey)}
            >
              <div className={styles["accordion-item-content"]}>
                <FixaText tagName="p" textStyle="Body.M">
                  {t("unauthorizedDisclaimerBodyString")}
                  <a
                    href={myIdentityLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["myidentity-link"]}
                  >
                    MyIdentity
                  </a>
                  {"."}
                </FixaText>
                <FixaButton
                  type="primary"
                  fluid
                  text={t("requestAccessString")}
                  onClick={() =>
                    window.open(myIdentityLink, "_blank", "noopener,noreferrer")
                  }
                />
              </div>
            </FixaAccordionItem>
          )
        )}
      </FixaAccordion>
    </div>
  );
};

export default UnauthorizedPageAccordion;
